module.exports = __webpack_public_path__ + "static/media/recruit.e8dad703.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/recruit.jpg
// module id = 489
// module chunks = 0